import Main from './containers/MainContainer';

export default Main;
